import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Feedback } from '@thiememeulenhoff/types';
import { FeedbackEndpointsService } from './feedback.endpoints.service';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  readonly #httpClient = inject(HttpClient);

  readonly #endpoints = inject(FeedbackEndpointsService);

  postFeedback(
    actor: string,
    arrangementCode: string,
    contentPath: string,
    message: string,
  ) {
    const endpoint = this.#endpoints.postEndpoint(arrangementCode);

    return this.#httpClient.post(
      endpoint,
      this.#endpoints.postBody(actor, arrangementCode, contentPath, message),
    );
  }

  getFeedbackByTeacher(
    actor: string,
    arrangementCode: string,
    contentPath: string,
  ) {
    const endpoint = this.#endpoints.getEndpointTeacher(
      actor,
      arrangementCode,
      contentPath,
    );

    return this.#httpClient.get<Array<Feedback>>(endpoint);
  }

  getFeedbackByStudent(arrangementCode: string, contentPath: string) {
    const endpoint = this.#endpoints.getEndpointStudent(
      arrangementCode,
      contentPath,
    );

    return this.#httpClient.get<Array<Feedback>>(endpoint);
  }
}
